<template>
  <h2>Registro de variables radiativas</h2>
  <TableUi>
    <thead>
      <tr>
        <th width="33.3333%">Radiación global de onda corta</th>
        <th width="33.3333%">Radiación directa de onda corta</th>
        <th>Radiación difusa de onda corta</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>
          <div class="image-background">
            <img
              :src="
                `${basePath}/images/LAMAR/monitoreo/Ndays_global_OC_BSRN.webp`
              "
              title="Temperatura del Aire"
              alt="Temperatura del Aire"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
        </td>
        <td>
          <div class="image-background">
            <img
              :src="
                `${basePath}/images/LAMAR/monitoreo/Ndays_directa_OC_BSRN.webp`
              "
              alt="Temperatura del Suelo"
              title="Temperatura del Suelo"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
        </td>
        <td>
          <div class="image-background">
            <img
              :src="
                `${basePath}/images/LAMAR/monitoreo/Ndays_difusa_OC_BSRN.webp`
              "
              alt="Humedad Atmosférica"
              title="Humedad Atmosférica"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
        </td>
      </tr>
    </tbody>
  </TableUi>
  <br />
  <TableUi>
    <thead>
      <tr>
        <th width="33.3333%">Radiación incidente de onda larga</th>
        <th width="33.3333%">Radiación emitida de onda larga</th>
        <th>Radiación neta</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>
          <div class="image-background">
            <img
              :src="
                `${basePath}/images/LAMAR/monitoreo/Ndays_incidente_OL_BSRN.webp`
              "
              alt="Pluviómetro"
              title="Pluviómetro"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
        </td>
        <td>
          <div class="image-background">
            <img
              :src="
                `${basePath}/images/LAMAR/monitoreo/Ndays_emitida_OL_BSRN.webp`
              "
              alt="Distrómetro"
              title="Distrómetro"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
        </td>
        <td>
          <div class="image-background">
            <img
              :src="
                `${basePath}/images/LAMAR/monitoreo/Ndays_neta_irrad_BSRN.webp`
              "
              alt="Radiación Infrarroja"
              title="Radiación Infrarroja"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
        </td>
      </tr>
    </tbody>
  </TableUi>
  <br />
  <br />
  <h2>Registro de nubes y precipitaciones por radar</h2>
  <TableUi>
    <thead>
      <tr>
        <th width="33.3333%">Reflectividad Equivalente (dBZ)</th>
        <th width="33.3333%">Velocidad Doppler (m/s)</th>
        <th>Relación de decorrelación lineal</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>
          <div class="image-background">
            <img
              :src="
                `http://met.igp.gob.pe/lamar/datos/Radar/ultimo.z1.png?v=${currentDate}`
              "
              alt="Reflectividad Equivalente"
              title="Reflectividad Equivalente"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
          <p>
            El factor de reflectividad equivalente (Ze): específica los tipos de
            hidrometeóros en un volumen de resolución, los colores intensos de
            rango positivo indican gotas de lluvia más grandes, mientras que los
            otros se trata de partículas de nube.
          </p>
        </td>
        <td>
          <div class="image-background">
            <img
              :src="
                `http://met.igp.gob.pe/lamar/datos/Radar/ultimo.v1.png?v=${currentDate}`
              "
              alt="Velocidad Doppler"
              title="Velocidad Doppler"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
          <p>
            Velocidad Doppler (VElg): indica con qué velocidad vertical se está
            moviendo los hidrometeoros a medida que varía la altura, se observa
            que los hidrometeoros ascienden (valores postivos) y descendien
            (valores negativos).
          </p>
        </td>
        <td>
          <div class="image-background">
            <img
              :src="
                `http://met.igp.gob.pe/lamar/datos/Radar/ultimo.ldr.png?v=${currentDate}`
              "
              alt="Relación de decorrelación"
              title="Relación de decorrelación"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
          <p>
            Relación de decorrelación lineal (LDR): el radar recibe el promedio
            espectro de potencia en dos canales (horizontal y vertical)
            polarizada linealmente, los cuales permiten clasificar tipos de
            objetivos que se encuentran en la baja atmósfera, como son los
            hidrometeoros, insectos,etc.
          </p>
        </td>
      </tr>
    </tbody>
  </TableUi>
  <br />
  <br />
  <h2 class="header">Observaciones con cámara de cielo</h2>
  <TableUi>
    <thead>
      <tr>
        <th width="50%">Cámara diurna</th>
        <th>Cámara nocturna</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <div class="image-background">
            <img
              :src="
                `http://met.igp.gob.pe/lamar/datos/lifecam/ultimo.jpg?v=${currentDate}`
              "
              alt="Cámara diurna"
              title="Cámara diurna"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
        </td>
        <td>
          <div class="image-background">
            <img
              :src="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
              alt="Cámara nocturna"
              title="Cámara nocturna"
              :onerror="
                `this.onerror=null;this.src='${basePath}/images/unavailable.svg';`
              "
              :broken="
                `http://met.igp.gob.pe/lamar/datos/oculus/ultimo.jpg?v=${currentDate}`
              "
            />
          </div>
        </td>
      </tr>
    </tbody>
  </TableUi>
</template>
<script>
import TableUi from "@/components/ui/objects/TableUi.vue";
export default {
  components: {
    TableUi
  },
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    const currentDate = new Date().getTime();
    return {
      basePath,
      currentDate
    };
  }
};
</script>
<style lang="scss" scoped>
.image-background {
  display: flex;
  justify-content: center;
}
</style>
